import { useCallback } from "react"

import { useAppDispatch, useAppSelector } from "stores/hooks"
import { ToastData } from "stores/ui/types"
import { selectUI, setCustomToast } from "stores/ui/uiSlice"

const useCustomToast = () => {
  const dispatch = useAppDispatch()
  const { toastData } = useAppSelector(selectUI)

  const customToast = useCallback(
    (payload: ToastData | null) => {
      if (payload) {
        dispatch(setCustomToast(payload))
        // Create cleanup timeout
        const timeoutId = setTimeout(() => {
          dispatch(setCustomToast(null))
        }, payload.duration || 2000)

        // Store timeout ID for cleanup
        return () => clearTimeout(timeoutId)
      }
      return undefined
    },
    [dispatch],
  )

  // Remove existing useEffect that handles duration

  return { customToast, toastData }
}

export default useCustomToast
